import React from 'react';

function SummaryCards({ summary }) {
  const cards = [
    { label: 'Coinciden', value: summary.coincide, icon: '✅', bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700', num: 'text-green-600' },
    { label: 'No coinciden', value: summary.no_coincide, icon: '❌', bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', num: 'text-red-600' },
    { label: 'Requiere revisión manual', value: summary.no_validable, icon: '⚠️', bg: 'bg-yellow-50', border: 'border-yellow-200', text: 'text-yellow-700', num: 'text-yellow-600' },
    { label: 'Datos fijos', value: summary.fijo, icon: 'ℹ️', bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', num: 'text-blue-600' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map(c => (
        <div key={c.label} className={`${c.bg} ${c.border} border rounded-xl p-4 text-center`}>
          <div className="text-3xl mb-1">{c.icon}</div>
          <div className={`text-3xl font-bold ${c.num}`}>{c.value}</div>
          <div className={`text-sm font-medium ${c.text} mt-1`}>{c.label}</div>
        </div>
      ))}
    </div>
  );
}

export default SummaryCards;
